import { format } from '@shared/wrappers/date/date';

export const formatDate = date => (date ? format(date, 'DD/MM/YYYY') : null);

export const isFieldWithError = (array, field) => array.indexOf(field) !== -1;
